/**
 * Mapping alter Disjunktiv-HBF-Codes (Stil "os V o. K") auf das neue
 * Pipe-getrennte Format ("os V | os K"). Der neue Stil erlaubt es, mit
 * Substring-Suche im Typeahead beide Einzel-Codes zu finden.
 *
 * Bohrpunkte aus älteren App-Versionen können noch alte Codes im
 * `Bodenform.bf[].hbf`-Feld haben. Diese Tabelle dient zur Übersetzung
 * bei Lookups (Import-Parser, ggf. Anzeige).
 */
export const LEGACY_HBF_CODE_MAP: Readonly<Record<string, string>> = Object.freeze({
  'kol SV o. SK':     'kol SV | kol SK',
  'kol V o. K':       'kol V | kol K',
  'kos V o. K':       'kos V | kos K',
  'kot SV o. SK':     'kot SV | kot SK',
  'kot/s AV oder KV': 'kot/s AV | kot/s KV',
  'ol SV o. SK':      'ol SV | ol SK',
  'ol V o. K':        'ol V | ol K',
  'ol/s AV o. AK':    'ol/s AV | ol/s AK',
  'ol/s V o. K':      'ol/s V | ol/s K',
  'os GV o. GK':      'os GV | os GK',
  'os V o. K':        'os V | os K',
  'ot SV o. SK':      'ot SV | ot SK',
  'ot/s AV o. AK':    'ot/s AV | ot/s AK',
});

/** Liefert den kanonischen HBF-Code zurück; akzeptiert auch alte Disjunktiv-Schreibweisen. */
export function normalizeHbfCode(code: string): string {
  return LEGACY_HBF_CODE_MAP[code] ?? code;
}
